import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {upperCaseFirstLetter} from '../../../../utils/index';
import Icon from '../../../icon';
import LanguageSelector from './components/language-selector';
import {isAndroid, isIOS} from 'react-device-detect';
import './index.css';

function BottomMenu () {

	const isMobileOrTabletDetected = useSelector(state => state.mobileReducer.isMobileOrTabletDetected);

	const { t } = useTranslation();

	return (
		<ul className={`bottom-menu`}>
			<li>
				<a href="https://chrome.google.com/webstore/detail/share-for-%E2%80%9Cgoogle-contact/nllecbomigehlngfclbgjeghfmfajfgp" target="_blank" rel="noreferrer">
					<Icon name="chrome"/>
					<span className="menu-item__text">Chrome Extension</span>
				</a>
			</li>
			{
				isMobileOrTabletDetected && isIOS && <li>
					<a href="https://apps.apple.com/gb/app/shared-contacts-for-gmail/id1527060811" target="_blank" rel="noreferrer">
						<img src="https://www.getsharedcontacts.com/wp-content/uploads/2021/05/Download_on_the_App_Store_Badge.svg" alt="iOS App" />
					</a>
				</li>
			}
			{
				isMobileOrTabletDetected && isAndroid && <li>
					<a href="https://play.google.com/store/apps/details?id=com.gmailsharedcontacts&amp;hl=en&amp;gl=US" target="_blank" rel="noreferrer">
						<img src="https://www.getsharedcontacts.com/wp-content/uploads/2021/05/Google_Play_Store_badge_EN.svg" alt="Android App" />
					</a>
				</li>
			}
			<li>
				<a href="https://docs.google.com/a/alti.mobi/forms/d/1wAcBo7INN7s345SUqnfDNIP2eHczciQ0gPsug79VGj8/viewform" target="_blank" rel="noopener noreferrer">
					<Icon name="heart"/>
					<span className="menu-item__text">{upperCaseFirstLetter(t("feedBacktext"))}</span>
				</a>
			</li>
			<li>
				<LanguageSelector />
			</li>
		</ul>
	)
}

export default BottomMenu;
